import AmericanExpressLogo from '../assets/images/americanexpress.png';
import DiscoverLogo from '../assets/images/discover.png';
import MasterCardLogo from '../assets/images/mastercard.png';
import VisaLogo from '../assets/images/visa.png';
import ApplePayMark from '../assets/images/applePayMark.svg';
import CreditCard from '../assets/images/creditCard.svg';
import Image from 'next/image';

export type PaymentMethodBrandProps = {
  brand: string;
};

const width = 43;
const height = 29;

type BrandsKeys = keyof typeof BRANDS;

const BRANDS = {
  apple: <Image width={width} height={height} src={ApplePayMark} alt="Apple Pay" />,
  amex: <Image width={width} height={height} src={AmericanExpressLogo} alt="American Express" />,
  discover: <Image width={width} height={height} src={DiscoverLogo} alt="Discover" />,
  mastercard: <Image width={width} height={height} src={MasterCardLogo} alt="MasterCard" />,
  visa: <Image width={width} height={height} src={VisaLogo} alt="Visa" />,
  unknown: <Image width={width} height={height} src={CreditCard} alt="Credit Card" />,
};

export function PaymentMethodBrand({ brand = 'unknown' }: PaymentMethodBrandProps) {
  return BRANDS[brand.toLowerCase() as BrandsKeys] || BRANDS.unknown;
}
